import { render, staticRenderFns } from "./VATReport.vue?vue&type=template&id=5e563086"
import script from "./VATReport.vue?vue&type=script&lang=js"
export * from "./VATReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports